import type { RunGroupPolicy, RunInstance } from "@skaile/workspaces/types";

/**
 * Whether a failed instance gets another attempt. `requeue` while the
 * error is recoverable and attempts remain (attempt is 1-based; maxRetries
 * is the RE-queue budget, so total attempts = maxRetries + 1). Retries
 * always imply a fresh session - no half-poisoned state.
 */
export function planRetry(
  instance: RunInstance & { status: "failed" },
  policy: RunGroupPolicy,
): "requeue" | "final_fail" {
  if (!instance.error || !instance.error.recoverable) return "final_fail";
  return instance.attempt <= policy.maxRetries ? "requeue" : "final_fail";
}
